export default __webpack_public_path__ + "static/media/16.e208f49b.png";